var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHospital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_760)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6583 21.8311C42.6583 28.2372 41.0624 32.5456 34.7946 38.3028C34.6773 38.4122 21.4844 49.638 21.4844 49.638C21.4844 49.638 8.2363 38.2219 8.11895 38.1125C3.32597 33.8978 0.318359 28.2372 0.318359 21.8311C0.318359 10.1374 9.79849 0.665039 21.4844 0.665039C33.1781 0.665039 42.6583 10.1374 42.6583 21.8311Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5642 38.5342C30.8763 38.5342 38.4253 30.9852 38.4253 21.6731C38.4253 12.361 30.8763 4.81201 21.5642 4.81201C12.2521 4.81201 4.70312 12.361 4.70312 21.6731C4.70312 30.9852 12.2521 38.5342 21.5642 38.5342Z",
    fill: "#A2DB67",
    stroke: "#55990E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9331 18.6731V24.6731H24.4929V31.123H18.4929V24.6731H12.043V18.6731H18.4929V12.2231H24.4929V18.6731H30.9331Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_760"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.318359 0.665039)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospital);
export default __webpack_public_path__ + "static/media/hospital.e279d17f5235757e939469b880dff239.svg";
export { ForwardRef as ReactComponent };